export const OPEN_MODAL = "OPEN_MODAL"
export const OPEN_RC = "OPEN_RC"
export const OPEN_MS = "OPEN_MS"
export const OPEN_TOUR = "OPEN_TOUR"
export const OPEN_WELCOME = "OPEN_WELCOME"
export const OPEN_ANN = "OPEN_ANN"
export const NOTIFY = "NOTIFY"
